import React from "react";
import Head from "next/head";

import PropertyDocuments from "components/PropertyDocuments";

import { useFormattedMessage } from "hooks";
import { watchvestAsset } from "i18n/messages/meta";
import { getDocumentsHost } from "common/helper";

const DOCUMENT_HOST = getDocumentsHost();

const WatchvestAsset01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen WATCHVEST-01",
        path: `${DOCUMENT_HOST}/docs/general/watchvest/watchvest-asset/WATCHVEST-01/Watchvest-Asset_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 06/2022 - PDF - 243 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WATCHVEST-01",
        path: `${DOCUMENT_HOST}/docs/general/watchvest/watchvest-asset/WATCHVEST-01/Watchvest-Asset_Basisinformationsblatt.pdf`,
        description: "Stand 06/2022 - PDF - 209 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WATCHVEST-01",
        path: `${DOCUMENT_HOST}/docs/general/watchvest/watchvest-asset/WATCHVEST-01/Watchvest-Asset_WATCHVEST-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 209 KB",
    },
];

const WatchvestAsset02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen WATCHVEST-02",
        path: `${DOCUMENT_HOST}/docs/general/watchvest/watchvest-asset/WATCHVEST-02/Watchvest-Asset_WATCHVEST-02_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 07/2022 - PDF - 336 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WATCHVEST-02",
        path: `${DOCUMENT_HOST}/docs/general/watchvest/watchvest-asset/WATCHVEST-02/Watchvest-Asset_WATCHVEST-02_Basisinformationsblatt.pdf`,
        description: "Stand 07/2022 - PDF - 204 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WATCHVEST-02",
        path: `${DOCUMENT_HOST}/docs/general/watchvest/watchvest-asset/WATCHVEST-02/Watchvest-Asset_WATCHVEST-02_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 204 KB",
    },
];

const WatchvestAsset03DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen WATCHVEST-03",
        path: `${DOCUMENT_HOST}/docs/general/watchvest/watchvest-asset/WATCHVEST-03/Watchvest-Asset_WATCHVEST-03_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 08/2022 - PDF - 332 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WATCHVEST-03",
        path: `${DOCUMENT_HOST}/docs/general/watchvest/watchvest-asset/WATCHVEST-03/Watchvest-Asset_WATCHVEST-03_Basisinformationsblatt.pdf`,
        description: "Stand 08/2022 - PDF - 214 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WATCHVEST-03",
        path: `${DOCUMENT_HOST}/docs/general/watchvest/watchvest-asset/WATCHVEST-03/Watchvest-Asset_WATCHVEST-03_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 214 KB",
    },
];

const WatchvestIssuerPage = () => {
    const { formatMessage } = useFormattedMessage();

    return (
        <>
            <Head>
                <title>{formatMessage(watchvestAsset.title)}</title>
                <meta name="description" content="Watchvest Asset GmbH" />
            </Head>
            <div className="broad-container issuer-public-page">
                <section className="banner-section" style={{ backgroundImage: "url(/images/watchvest-asset-banner.jpg)" }} />
                <section className="content-section small-container">
                    <div className="header-part">
                        <div className="logo-container shadow border-radius">
                            <img src={"/images/watchvest-asset-banner.png"} alt="" />
                        </div>
                        <p>
                            Gegenstand des Unternehmens ist der An- und Verkauf von Uhren. Die Gesellschaft ist zu allen
                            Geschäften und Maßnahmen berechtigt, die zur Erreichung des Gesellschaftszweckes notwendig oder
                            nützlich erscheinen, zur Errichtung von Zweigniederlassungen und zur Beteiligung an anderen
                            Unternehmen.
                        </p>
                    </div>
                    <div className="border-x" />
                    <div className="content-part">
                        <h2>Watchvest Asset GmbH</h2>
                        <p>Bei der Finanzierung verfolgt die Watchvest Asset GmbH eine langfristig ausgerichtete Strategie.</p>
                    </div>
                    <div className="two-parts">
                        <div className="first-part">
                            <div className="pdf-part">
                                <h3>Kapitalmarktdokumentation</h3>
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={WatchvestAsset01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={WatchvestAsset02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={WatchvestAsset03DocumentsData} />
                                <span className="bottom-line text-14 d-block">
                                    *Basisinformationsblatt gemäß EU-Verordnung 1286/2014
                                </span>
                            </div>
                        </div>
                        <div className="second-part">
                            <h3>Kontakt</h3>
                            <p>
                                Bei Fragen zu den tokenisierten Schuldverschreibungen sind wir persönlich erreichbar über die
                                E-Mail-Adresse:
                                <br />
                                <a href="mailto:info@watchvest.com">info@watchvest.com</a>
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

WatchvestIssuerPage.getInitialProps = async ({ res, req, isServer }) => {
    if (req?.tenant !== "watchvest") res.redirect("/404");
    return { isServer };
};

export default WatchvestIssuerPage;
